function normaliseFolloweeType(followeeType) {
  return followeeType === "gallery_artist" ? "gallery_artist" : "user";
}

export function createFollowMutationCoordinator() {
  const latestMutations = new Map();

  return {
    begin(cacheKey) {
      const mutationId = Symbol(cacheKey);
      latestMutations.set(cacheKey, mutationId);
      return mutationId;
    },
    isCurrent(cacheKey, mutationId) {
      return latestMutations.get(cacheKey) === mutationId;
    },
    complete(cacheKey, mutationId) {
      if (latestMutations.get(cacheKey) === mutationId) {
        latestMutations.delete(cacheKey);
      }
    },
  };
}

export const followMutationCoordinator = createFollowMutationCoordinator();

export function getFollowStateCacheKey({ followeeType = "user", userId } = {}) {
  if (userId === null || userId === undefined || String(userId).trim() === "") {
    return null;
  }
  return `user_actions.follow.${normaliseFolloweeType(followeeType)}.${userId}`;
}

export function readCachedFollowState(cacheHandler, options = {}) {
  const cacheKey = getFollowStateCacheKey(options);
  if (!cacheKey) {
    return null;
  }
  const cachedValue = cacheHandler?.getCacheValue?.(cacheKey)?.data;
  return typeof cachedValue === "boolean" ? cachedValue : null;
}

export function resolveFollowState({ cacheHandler, imFollowing, ...options } = {}) {
  const cachedValue = readCachedFollowState(cacheHandler, options);
  if (cachedValue !== null) {
    return cachedValue;
  }
  return typeof imFollowing === "boolean" ? imFollowing : null;
}

export function isSuccessfulFollowResponse(result) {
  return result?.response?.ok === true;
}
